import React from 'react'
import type { IconProps } from '@strata-monorepo/shared-ui/types/Svg'

const EditIcon = ({ classNames, ...props }: IconProps): React.ReactElement => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={classNames}
    {...props}
  >
    <path
      d='M3.33333 13.9999C2.96667 13.9999 2.65278 13.8693 2.39167 13.6082C2.13056 13.3471 2 13.0332 2 12.6666V3.33324C2 2.96657 2.13056 2.65268 2.39167 2.39157C2.65278 2.13046 2.96667 1.9999 3.33333 1.9999H9.28333L7.95 3.33324H3.33333V12.6666H12.6667V8.03324L14 6.6999V12.6666C14 13.0332 13.8694 13.3471 13.6083 13.6082C13.3472 13.8693 13.0333 13.9999 12.6667 13.9999H3.33333ZM6 9.33324V7.71657C6 7.53879 6.03333 7.36935 6.1 7.20824C6.16667 7.04713 6.26111 6.90546 6.38333 6.78324L12.1167 1.0499C12.25 0.916569 12.4 0.816569 12.5667 0.749902C12.7333 0.683236 12.9 0.649902 13.0667 0.649902C13.2444 0.649902 13.4139 0.683236 13.575 0.749902C13.7361 0.816569 13.8833 0.916569 14.0167 1.0499L14.95 1.9999C15.0722 2.13324 15.1667 2.28046 15.2333 2.44157C15.3 2.60268 15.3333 2.76657 15.3333 2.93324C15.3333 3.0999 15.3028 3.26379 15.2417 3.4249C15.1806 3.58601 15.0833 3.73324 14.95 3.86657L9.21667 9.5999C9.09444 9.72213 8.95278 9.81935 8.79167 9.89157C8.63056 9.96379 8.46111 9.9999 8.28333 9.9999H6.66667C6.47778 9.9999 6.31944 9.93601 6.19167 9.80824C6.06389 9.68046 6 9.52213 6 9.33324ZM7.33333 8.66657H8.26667L12.1333 4.7999L11.6667 4.33324L11.1833 3.86657L7.33333 7.71657V8.66657Z'
      fill='currentColor'
    />
  </svg>
)

export default EditIcon
